import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import {Instagram, Tiktok, Youtube, Linkedin, Pinterest, Headphones} from 'react-bootstrap-icons'
import { DraftContext } from '../../../../../../contexts/DraftContext'

export default observer(function InfluencerActionPlatform({ platform, influencer }) {
  const { draftState } = useContext(DraftContext)
  const icon = {
    instagram: <Instagram />,
    tiktok: <Tiktok />,
    youtube: <Youtube />,
    linkedin: <Linkedin />,
    pinterest: <Pinterest />,
    podcast: <Headphones />,
  }

  return (
    <div className="py-3">
      <button
        className={`w-10 h-10 ml-2 border-1 dark:border-rb-dark-mode-lighter rounded-lg text-black dark:text-white flex justify-center items-center ${influencer.selectedPlatform === platform ? 'bg-rb-soft-green dark:bg-rb-dark-mode-lighter border-1 border-rb-green dark:border-rb-green text-rb-green dark:text-rb-green' : 'bg-white dark:bg-rb-dark-mode hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter'}`}
        onClick={() => {
          influencer.selectedPlatform = platform
        }}
        >
          { icon[platform] }
        </button>
    </div>
  )
})
